import React from "react";
import "../incomeAnalyzer.scss";
const InternalError = ({ data }) => {
	console.log('data', data)
	return (
		<>
			<div className="no-item-blc text-center right-col d-flex align-items-center justify-content-center">
				{data}
			</div>
		</>
	);
}

export default InternalError;